
export class PaymentGatewayOrderInfo {

  gatewayName : string

  orderId : string
}
